import React, { useState } from 'react';

const CopyText = ({ text, copy }) => {
    const [isCopy, setIsCopy] = useState(false);
  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(copy);
      setIsCopy(true);
      setTimeout(() => {
        setIsCopy(false);
      }, 1000);
    } catch (err) {
      console.error('Impossible de copier le texte :', err);
    }
  };

  return (
    <span onClick={handleClick} style={{ cursor: 'pointer', position: 'relative', display: 'inline'}}>
        {isCopy ? <div className='msg-copy'>Copié !</div> : ''}
        {text} 
    </span>
  );
};

export default CopyText;
